(function () {
  const ingridientContainer = document.querySelector(".ingridients__content");
  const ingridientSwiper = document.querySelector(".ingridients__swiper");
  const ingredientContent = document.querySelector(".ingridients__content");

  ["DOMContentLoaded", "resize"].forEach((itemEvent, index) => {
    window.addEventListener(itemEvent, function () {
      changeHeight()
      setContainerMargin(ingridientContainer);
      if (index === 0) initSlider(ingridientSwiper);
    })
  })

  ingredientContent?.addEventListener("click", function (event) {
    changeDescription(event)
  })



  function initSlider(swiperElement) {
    if (!Swiper || !swiperElement) return;
    return new Swiper(swiperElement, {
      slidesPerView: "auto",
      loop: false,
      watchSlidesProgress: true,
      touchRatio: 1,
      threshold: 10
    })
  }


  function setContainerMargin(container) {
    if (!container && window.innerWidth > 768) return;
    const styles = getContainerStyles(container);
    const correctWidth = styles.width + styles.marginRight;
    const marginRight = Math.max(0, (window.innerWidth - correctWidth) / 2);

    container.style.maxWidth = `calc(100% + ${marginRight}px)`;
    container.style.marginRight = `-${marginRight}px`;
  }

  function getContainerStyles(container) {
    const styles = getComputedStyle(container);
    return {
      width: parseFloat(styles.width),
      marginRight: parseFloat(styles.marginRight),
    };
  }


  function changeDescription(event) {
    if (!event?.target.classList.contains("ingridients__slide-list-item")) return;

    const target = event.target;
    const nameTag = target.querySelector(".ingridients__slide-list--tag");
    const hiddenTag = target.querySelector(".ingridients__slide-list--hide");
    const targetDescription = target.closest(".ingridients__slide").querySelector(".ingridients__slide-description__content");
    const targetNameTag = target.closest(".ingridients__slide").querySelector(".ingridients__slide-description__title");
    const allTagTarget = target.closest(".ingridients__slide").querySelectorAll(".ingridients__slide-list-item");

    if (!hiddenTag && !targetDescription) return;
    targetDescription.innerHTML = hiddenTag.innerHTML;
    targetNameTag.innerHTML = nameTag.innerHTML;
    allTagTarget.forEach(tag => tag.classList.remove("ingridients__slide-list-item-active"));
    target.classList.add("ingridients__slide-list-item-active");
    changeHeight()
  }

  function changeHeight() {
    let blocksContent = document.querySelectorAll(".ingridients__slide-description")
    blocksContent.forEach(block => {
      block.style.height = "fit-content"
    })
    let arrayHeight = [...blocksContent].map(block => {
      return Number(getComputedStyle(block).height.replace("px", ""));
    })
    let paddingKoeff = 0
    let maxHeight = Math.max(...arrayHeight);
    blocksContent.forEach(block => {
      block.style.height = maxHeight + paddingKoeff + "px"
    })
  }
})()